import { useQuery } from 'react-query';

import { ListingDetails, Token } from '@keaze/web/common/interfaces';
import {
  getListingBySlug,
  ExpectedGetListingBySlug,
} from '@keaze/web/api/listings/getListingBySlug';

type UseGetListingBySlugQueryArgs = {
  token: Token;
  listingSlug: string;
  initialData: ListingDetails;
};

export const useGetListingBySlugQuery = ({
  initialData,
  ...restArgs
}: UseGetListingBySlugQueryArgs) =>
  useQuery<ExpectedGetListingBySlug, Error>(
    ['listing details', restArgs],
    () => getListingBySlug(restArgs),
    {
      initialData,
      keepPreviousData: true,
    }
  );
